import React, { useState } from "react";
import Body from "./Body";

const StudentsProfile = () => {
  const [studentsData, setStudentsData] = useState([
    {
      name: "Akhil Zabed",
      gender: "Male",
      fathersName: "Jakir Hossain",
      mothersName: "Farida Khatun",
      gurdian: "Md Rejuwanul Karim",
      guardianPhoneNo: "7478919026",
      aadhaarNo: "154867512976",
      dob: "03/06/2025",
      pincode: "700160",
      nationality: "Pakistani",
      phoneNo: "9754826418",
      email: "ajkabed@gmail.com",
      id: "SM1000000",
      reportingTeacher: {
        name: "Teacher 1",
        id: "34567100",
      },
      attendance: "60%",
      performance: {
        score: "50%",
        trend: "Down",
      },
      latestPayment: "August",
      subjectStrengths: [
        {
          name: "Bengali",
          strength: "30",
          totalVal: "100",
          color: "#ec2658",
          backgroundColor: "#ffe5ec",
        },
        {
          name: "English",
          strength: "30",
          totalVal: "100",
          color: "green",
          backgroundColor: "#e0f7e9",
        },
        {
          name: "Hindi",
          strength: "30",
          totalVal: "100",
          color: "#ff9d00",
          backgroundColor: "#fff3e0",
        },
        {
          name: "Marathi",
          strength: "30",
          totalVal: "100",
          color: "purple",
          backgroundColor: "#f3e5f5",
        },
        {
          name: "Physics",
          strength: "30",
          totalVal: "100",
          color: "#b0b0b0",
          backgroundColor: "#f5f5f5",
        },
        {
          name: "Life Science",
          strength: "30",
          totalVal: "100",
          color: "#ffae5d",
          backgroundColor: "#fff1e3",
        },
        {
          name: "History",
          strength: "30",
          totalVal: "100",
          color: "#0d00ff",
          backgroundColor: "#e5e7ff",
        },
      ],
      subjectWeakness: "Physics",
      extraActivity: "Sports",
      behavior: "Excellent",
      achievements: [
        {
          title: "Math Olympiad",
          position: "Gold Medalist",
        },
        {
          title: "Jr. Boxing Championship",
          position: "Runner up",
        },
      ],
      likeToDo: "Play Kabadi",
      address: "10 Greenway Avenue, City 0, PIN-400000",
      residential: {
        buildingName: "Rabindra bhaban",
        floor: "1st floor",
        roomNo: "3",
        bedNo: "15",
        roomTeacher: "Shubham Khan",
        floorSuperintendent: "Shubham Khan",
      },
      academic: {
        admissionData: "3 July, 2024",
        endSession: "N/A",
        currentClass: "6",
        admissionClass: "5",
        section: "A",
        rollNo: "25",
        reportingTeacher: "Md Rejuwanul Karim",
        yearlyFees: "40,000",
        monthlyFees: "2500",
        feesType: "Concession/Scholarship",
        latestPayment: "Current",
        hobbies: ["Play Cricket", "reading books"],
        extraActivity: "Coding",
        behavior: "Excellent",
      },
    },
  ]);
  const [grades, setGrades] = useState([
    { subject: "Bengali", grade: "D", color: "#0000FF" }, // Blue
    { subject: "English", grade: "A", color: "#008000" }, // Green
    { subject: "History", grade: "AA", color: "#FFD700" }, // Yellow
    { subject: "Geography", grade: "B+", color: "#4B0082" }, // Dark Purple
    { subject: "Life Science", grade: "AA", color: "#4B0082" }, // Dark Purple
    { subject: "Physical Science", grade: "B", color: "#FF8C00" }, // Orange
    { subject: "Mathematics", grade: "A+", color: "#B22222" }, // Red
  ]);
  const [gradeSystem, setGradeSystem] = useState([
    { grade: "AA", percentage: "100%", color: "#4B0082" },
    { grade: "A+", percentage: "90%-99%", color: "#0000FF" },
    { grade: "A", percentage: "75%-89%", color: "#008000" },
    { grade: "B+", percentage: "60%-74%", color: "#FFD700" },
    { grade: "B", percentage: "30%-59%", color: "#FF8C00" },
    { grade: "D", percentage: "<30% Fail", color: "#B22222" },
  ]);
  // const [donutChartData, setDonutChartData] = useState([
  //   {
  //   subject:"English",
  //   strength:"",
  //   color:"",

  // },
  // ]);

  const convertToTitleCase = (str) => {
    if (!str) {
      return ""; // Handle empty or null strings
    }
    return str.replace(/([A-Z])/g, " $1").replace(/^./, function (str) {
      return str.toUpperCase();
    });
  };

  const _this = {
    studentsData,
    setStudentsData,
    convertToTitleCase,
    grades,
    setGrades,
    gradeSystem,
    setGradeSystem,
  };
  return <Body {..._this} />;
};

export default StudentsProfile;
